<template>
  <div>
    
    <default-financial-card :background_color="background_color" :value="data_goal" :title="title" :icon="icon" :title_class="title_class" :icon_color="icon_color">
      <template v-slot:extra>
        {{data_percent}}% da meta atingida
      </template>

    </default-financial-card>
    
  </div>
</template>

<script>
export default {
  name: 'Goal',

  components: {
    DefaultFinancialCard: () => import ('./DefaultFinancialCard.vue'),
  },

  props: {
    data: {
      type: Object,
    },
  },

  data() {
    return {
      //value: 20000,
      value_percent: 20,
      title: 'Meta',
      icon: 'mdi-bullseye-arrow',
      title_class: 'deep-purple--text overline',
      icon_color: 'orange',
      background_color: 'rgba(245,156,52,0.4)',
    }
  },

  computed: {
    data_total() {
      let val = 0
      if (this.data && this.data.total){
        val = (Number(this.data.total)/100)
      }
      return Number(val).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) 
    },
    data_goal() {
      // let val = 0
      // if (this.data && this.data.base_monthly_goal){
      //   val = (Number(this.data.base_monthly_goal)/100)
      // }
      return this.data.base_monthly_goal //Number(val).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
    },
    data_percent() {
      let val = 0
      if (this.data){
        let {total, base_monthly_goal} = this.data
        val = (Number((total || 0) / (base_monthly_goal||1))*100).toFixed(2)
      }
      return val
    },
  },

}
</script>

<style lang="scss" scoped>

</style>